import React from 'react';
import "./styles.scss";
import ImageGridSplit from "../ImageGridSplit";
import ImageGridSingle from "../ImageGridSingle";
import {ImageGridProps} from "./props";

function ImageGrid({singleGrid}: ImageGridProps) {
  return (
    <div className="image-grid">      
      <ImageGridSplit/>      
      <ImageGridSingle {...singleGrid} />      
    </div>
  );
}

export default React.memo(ImageGrid);